<template>
    <div class="adjust-order">
        
        <el-button type="text" @click="toggleDialog" size="small">
            <span v-if="value.length > 0">已选择{{value.length}}项</span>
            <span v-else>选择调账单据</span>
        </el-button>
        <el-dialog title="选择单据" :visible.sync="dialogTableVisible">
            <el-table 
                :data="gridData" 
                height="300"
                ref="table"
                @selection-change="handleSelectionChange">
                 <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  type="index"
                  width="50">
                </el-table-column>
                <el-table-column property="transaction_no_display" label="单据号"></el-table-column>
                <el-table-column property="work_time" label="日期" width="150"></el-table-column>
                <el-table-column property="amount" label="金额" width="100"></el-table-column>
            </el-table>
            <template slot='footer'>
            <div>
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
            </div>
            </template>
        </el-dialog>    
    </div>
</template>
<script>
    export default {
        name: 'LyAdjustOrder',
        props: {
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            productId: {
               type: [String, Number],
               default: 0
            }, // 货品ID
            warehouseId: { // 仓库ID
                type: [String, Number],
                default: ''
            },
            providerId: {
                type: [String, Number],
                default: 0
            }, // 供应商ID
            dateStart: {
                type: String, 
                default: ''
            }, // 起始时间
            dateEnd: {
                type: String,
                default: ''
            }, // 结束时间
            isFengcang: {
                type: Boolean,
                default: false 
            } // 是否有分仓
        },
        watch: {
            productId () {
                // 货品变化时，数据清空
                this.clearData()
            },
            warehouseId () {
                this.clearData()
            },
            providerId () {
                this.clearData()
            },
            dateStart () {
                this.clearData()
            },
            dateEnd () {
                this.clearData()
            }
        },
        data () {
            return {
                dialogTableVisible: false, // 对话框的显示标识
                gridData: [] // 表格中的数据
            }
        },
        methods: {
            /**
             * 数据的获取
             * @return {[type]} [description]
             */
            queryData () {
                this.$api.query('api/caigoucetzlist', {
                    product_id: this.productId,
                    warehouse_id: this.warehouseId,
                    provider_id: this.providerId,
                    date_start: this.dateStart,
                    date_end: this.dateEnd
                }).then((rs) => {
                    this.totalNum = rs.total_num
                    this.gridData = rs.data
                    // 设置默认数据的选中
                    this.rowChecked()
                }).catch((err) => {
                    console.error('adjust-order query error:%O', err)
                })
            },
            /**
             * 对话框的显示控制
             * @return {[type]} [description]
             */
            toggleDialog () {
                let msg = ''
                // 判断查询的条件
                if (this.providerId <= 0) {
                    msg = '还未选择供应商'
                } else if (this.isFengcang && this.warehouseId <= 0) {
                    msg = '还未选择仓库'
                } else if (this.productId <= 0) {
                    msg = '还未选择货品'
                }
                if (msg.length > 0) {
                    this.$message({
                        message: msg,
                        type: 'warning'
                    })
                } else {
                    this.dialogTableVisible = true
                    // 数据的获取
                    if (this.gridData.length < 1) {
                        this.queryData()
                    }
                }
            },
            /**
             * 表格勾选的事件监听
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleSelectionChange (val) {
                this.$emit('input', val)
            },
            /**
             * 行的默认选择
             * @return {[type]} [description]
             */
            rowChecked () {
                let inter = setInterval(() => {
                    if (this.$refs.table) {
                        clearInterval(inter)
                        for (let i in this.value) {
                            for (let j in this.gridData) {
                                if (this.gridData[j]['id'] === this.value[i]['id']) {
                                    this.$refs.table.toggleRowSelection(this.gridData[i],true)
                                }
                            }
                        }
                    }
                }, 100)
            },
            /**
             * 数据的清空
             * @return {[type]} [description]
             */
            clearData () {
                if (this.gridData.length > 0) {
                    this.gridData = []
                }
            }
            
        }
    }
</script>